"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagMapPoint = exports.CIRCLE_SIZE_PX = exports.CIRCLE_RADIUS = exports.CSS = void 0;
exports.view = view;
var core_shared_1 = require("@ikegps/core-shared");
var theme_1 = require("../../components/theme");
var theme_palette_1 = require("../../components/theme.palette");
var dom_1 = require("../../dom");
var mithril_1 = require("../../mithril");
var page_state_1 = require("../../state/page.state");
exports.CSS = {
    container: 'c-MapTag',
    point: 'c-MapTag__point',
    title: 'c-MapTag__title',
    isHovered: 'c-MapTag--is-hovered',
    isSelected: 'c-MapTag--is-selected'
};
exports.CIRCLE_RADIUS = theme_1.DefaultTheme.spacingFactor * 4;
exports.CIRCLE_SIZE_PX = exports.CIRCLE_RADIUS * 2 + 'px';
(0, theme_1.addStyles)((_a = {},
    _a[exports.CSS.point] = {
        height: exports.CIRCLE_SIZE_PX,
        width: exports.CIRCLE_SIZE_PX,
        minWidth: exports.CIRCLE_SIZE_PX,
        maxWidth: exports.CIRCLE_SIZE_PX,
        borderRadius: '50%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontFamily: theme_1.DefaultTheme.font.familyCondensed,
        fontWeight: theme_1.DefaultTheme.font.weight.bold,
        boxShadow: theme_1.DefaultTheme.shadow.box.dp2,
        textShadow: theme_1.DefaultTheme.shadow.text,
        position: 'absolute',
        cursor: 'pointer',
        color: theme_1.DefaultTheme.font.color.white,
        border: "2px solid ".concat(theme_1.DefaultTheme.font.color.white)
    },
    _a[exports.CSS.title] = {
        fontFamily: theme_1.DefaultTheme.font.familyCondensed,
        fontWeight: theme_1.DefaultTheme.font.weight.bold,
        backgroundColor: '#FFF',
        height: theme_1.DefaultTheme.space(6),
        lineHeight: theme_1.DefaultTheme.space(6),
        boxShadow: theme_1.DefaultTheme.shadow.box.dp2,
        fontSize: '125%',
        position: 'absolute',
        width: '120px',
        padding: '4px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        textAlign: 'center',
        whiteSpace: 'no-wrap'
    },
    _a["".concat(exports.CSS.point, ".").concat(exports.CSS.isHovered)] = {
        boxShadow: theme_1.DefaultTheme.shadow.box.dp2w5
    },
    _a[exports.CSS.isHovered] = {
        zIndex: 99
    },
    _a[exports.CSS.isSelected] = {
        boxShadow: "0 0 0 3px rgba(".concat(theme_palette_1.ColorPaletteOrange.C700, ", 0.24), 0 0 0 3px rgba(").concat(theme_palette_1.ColorPaletteOrange.C700, ", 0.64)")
    },
    _a["".concat(exports.CSS.point, ".").concat(exports.CSS.isHovered, ".").concat(exports.CSS.isSelected)] = {
        boxShadow: "0 0 0 5px rgba(".concat(theme_palette_1.ColorPaletteOrange.C700, ", 0.24), 0 0 0 5px rgba(").concat(theme_palette_1.ColorPaletteOrange.C700, ", 0.64)")
    },
    _a));
function view(tag, summary, point) {
    var _a, _b;
    var isHovered = page_state_1.CurrentState.hoverId === tag.objectId;
    var isSelected = page_state_1.CurrentState.Tag.isTagSelected(tag.objectId);
    var domPoint = (0, mithril_1.m)('div', (_a = {
            key: tag.objectId
        },
        _a[dom_1.DRAGON_ID] = tag.objectId,
        _a[dom_1.DRAGON_TYPE] = dom_1.DragonDomTypes.TAG,
        _a.className = "".concat(exports.CSS.point, " ").concat(isHovered ? exports.CSS.isHovered : '', " ").concat(isSelected ? exports.CSS.isSelected : ''),
        _a.style = {
            backgroundColor: core_shared_1.ColorHash.hash(tag.objectId),
            top: point.y - exports.CIRCLE_RADIUS + 'px',
            left: point.x - exports.CIRCLE_RADIUS + 'px'
        },
        _a), summary.revisions.length);
    if (isHovered) {
        return (0, mithril_1.m)('div', [
            domPoint,
            (0, mithril_1.m)('div', (_b = {},
                _b[dom_1.DRAGON_ID] = tag.objectId,
                _b[dom_1.DRAGON_TYPE] = dom_1.DragonDomTypes.TAG,
                _b.className = "".concat(exports.CSS.title, " ").concat(exports.CSS.isHovered),
                _b.style = {
                    top: point.y - theme_1.DefaultTheme.spacingFactor * 14 + 'px',
                    left: point.x - 60 + 'px'
                },
                _b), tag.name)
        ]);
    }
    return domPoint;
}
exports.TagMapPoint = { view: view, Radius: exports.CIRCLE_RADIUS };
//# sourceMappingURL=point.tag.js.map